export default {
      id: "138,4_cm_=_90_+_45-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#138,4_cm_=_90_+_45",
      toString: function () {
        return this.url;
      }
    }